import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  ref: "outer",
  class: "memories-searchbar"
}
const _hoisted_2 = { class: "searchbar-results" }
const _hoisted_3 = {
  key: 0,
  class: "empty"
}
const _hoisted_4 = {
  key: 1,
  class: "empty"
}
const _hoisted_5 = {
  key: 2,
  class: "empty"
}
const _hoisted_6 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MagnifyIcon = _resolveComponent("MagnifyIcon")!
  const _component_NcTextField = _resolveComponent("NcTextField")!
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!
  const _component_AlbumIcon = _resolveComponent("AlbumIcon")!
  const _component_LocationIcon = _resolveComponent("LocationIcon")!
  const _component_TagIcon = _resolveComponent("TagIcon")!
  const _component_XImg = _resolveComponent("XImg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NcPopover = _resolveComponent("NcPopover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NcPopover, {
      shown: _ctx.shown,
      "focus-trap": false,
      onAfterHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pHidden = true))
    }, {
      trigger: _withCtx(({ attrs }) => [
        _createElementVNode("div", _normalizeProps(_guardReactiveProps(attrs)), [
          _createVNode(_component_NcTextField, {
            ref: "textField",
            class: "text-field",
            modelValue: _ctx.prompt,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.prompt) = $event)),
            "label-outside": true,
            label: _ctx.t('memories', 'Search your photos …'),
            placeholder: _ctx.t('memories', 'Search your photos …')
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_MagnifyIcon, { size: 16 })
            ]),
            _: 1
          }, 8, ["modelValue", "label", "placeholder"])
        ], 16)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.prompt.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.t('memories', 'Start typing to find photos and albums')), 1))
            : (!_ctx.clusters && _ctx.clustersLoad)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_XLoadingIcon, { class: "fill-block" })
                ]))
              : (_ctx.clustersResult.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.t('memories', 'No results found')), 1))
                : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clustersResult, (cluster) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              class: "cluster",
              to: _ctx.clusterTarget(cluster),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.select()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.clusterIs.album(cluster))
                    ? (_openBlock(), _createBlock(_component_AlbumIcon, {
                        key: 0,
                        size: 22
                      }))
                    : (_ctx.clusterIs.place(cluster))
                      ? (_openBlock(), _createBlock(_component_LocationIcon, {
                          key: 1,
                          size: 22
                        }))
                      : (_ctx.clusterIs.tag(cluster))
                        ? (_openBlock(), _createBlock(_component_TagIcon, {
                            key: 2,
                            size: 22
                          }))
                        : (_ctx.clusterIs.face(cluster))
                          ? (_openBlock(), _createBlock(_component_XImg, {
                              key: 3,
                              src: _ctx.clusterPreview(cluster),
                              class: "preview-image"
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock(_component_MagnifyIcon, {
                              key: 4,
                              size: 22
                            }))
                ]),
                _createTextVNode(" " + _toDisplayString(cluster.display_name ?? cluster.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["shown"])
  ], 512))
}